var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxOutlinePaintbucket(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.7 19.56 3.24 16.1C.3 13.16.6 12.03 3.24 9.38L8.81 3.8c1.97-1.97 3.6-3.12 6.72 0l3.46 3.46c2.81 2.81 2.13 4.59 0 6.72l-5.57 5.57c-1.35 1.35-2.35 2.03-3.36 2.03-1 0-2.01-.68-3.36-2.02zm1.06-1.07c2.12 2.12 2.47 2.13 4.6 0l5.57-5.57c1.67-1.67 2.1-2.5 0-4.6l-3.46-3.46c-2.19-2.19-2.85-1.74-4.6 0L4.3 10.43c-2.12 2.13-2.3 2.3 0 4.6l3.46 3.46zM17.66 20.25c-.44-.77-.35-1.77.24-2.75l.66-1.09c.39-.64.96-1.01 1.58-1.01.62 0 1.2.37 1.58 1.01l.66 1.09c.59.98.67 1.98.24 2.75-.43.77-1.35 1.21-2.48 1.21-1.14 0-2.04-.44-2.48-1.21zm2.18-3.07-.66 1.09c-.3.5-.38.95-.22 1.24.16.29.59.45 1.17.45s1.01-.16 1.17-.45c.16-.29.08-.73-.22-1.24l-.66-1.09c-.11-.21-.23-.28-.28-.28-.05 0-.17.08-.3.28z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.28 12.44a.75.75 0 0 1 .53-.92 34.126 34.126 0 0 1 17.38-.13l.5.13a.75.75 0 0 1-.37 1.45l-.5-.13a32.472 32.472 0 0 0-16.61.13c-.08.02-.15.02-.21.02-.33 0-.63-.22-.72-.55z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlinePaintbucket);
export default __webpack_public_path__ + "static/media/vuesax-outline-paintbucket.e3903e36b7b868faa79756a7ffae6b3f.svg";
export { ForwardRef as ReactComponent };